module.exports = __webpack_public_path__ + "/images/ico-round-colaboracion.d37c8aa.svg";